import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @see http://download.oracle.com/javase/6/docs/api/java/util/Collection.html
 */
var Collection = /*#__PURE__*/function () {
  function Collection() {
    _classCallCheck(this, Collection);
  }
  _createClass(Collection, [{
    key: "add",
    /**
       * Ensures that this collection contains the specified element (optional
       * operation).
       * @param {Object} e
       * @return {boolean}
       */
    value: function add() {}
    /**
       * Appends all of the elements in the specified collection to the end of this
       * list, in the order that they are returned by the specified collection's
       * iterator (optional operation).
       * @param {javascript.util.Collection} c
       * @return {boolean}
       */
  }, {
    key: "addAll",
    value: function addAll() {}
    /**
       * Returns true if this collection contains no elements.
       * @return {boolean}
       */
  }, {
    key: "isEmpty",
    value: function isEmpty() {}
    /**
       * Returns an iterator over the elements in this collection.
       * @return {javascript.util.Iterator}
       */
  }, {
    key: "iterator",
    value: function iterator() {}
    /**
       * Returns an iterator over the elements in this collection.
       * @return {number}
       */
  }, {
    key: "size",
    value: function size() {}
    /**
       * Returns an array containing all of the elements in this collection.
       * @return {Array}
       */
  }, {
    key: "toArray",
    value: function toArray() {}
    /**
       * Removes a single instance of the specified element from this collection if it
       * is present. (optional)
       * @param {Object} e
       * @return {boolean}
       */
  }, {
    key: "remove",
    value: function remove() {}
  }]);
  return Collection;
}();
export { Collection as default };